import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import { SvgIconProps } from "@mui/material";

export const VisibilityOff = (props: SvgIconProps) => {
  return <VisibilityOffIcon data-testcomp="Icon_VisibilityOff" {...props} />;
};
